// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-card__wrap-image{position:relative}.content-card__image{max-height:100%;max-width:100%;-o-object-fit:contain;object-fit:contain;position:absolute}.content-card.v-sheet.v-card:not(.v-sheet--outlined){box-shadow:0 0 4px 0 rgba(0,0,0,.15),0 3px 4px 0 rgba(0,0,0,.14)}.content-card__card.v-sheet.v-card:not(.v-sheet--outlined){box-shadow:0 -2px 4px 0 rgba(0,0,0,.1)}.content-card--image-240 .content-card__wrap-image{height:240px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
